<template>
  <v-container fluid>
    <v-row>
        <v-col>
          <!--<v-card-title>
            <v-spacer></v-spacer>
          <v-btn  
              v-if="(($store.state.user.crear_expedientes && $route.name =='expedientes') || ($route.name =='carpeta_personal'))"
              rounded dark class="mr-4" color="primary"
              :to="{name: 'expediente_documento'}">
              <v-icon color="lighten-1">mdi-plus</v-icon>
              documento con flujo
            </v-btn>
         
          </v-card-title>
           -->
          <DataTableServerSideLotes opt="lotes">
          </DataTableServerSideLotes>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTableServerSideLotes from '@/views/Lotes/DataTableServerSideLotes.vue';
export default {
  components: { DataTableServerSideLotes },
  data: function() {
    return {
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {

  },
  mounted() {
    
  },
  methods: {

  },
};
</script>